angular.module('invoice')
    .constant('InvoiceAccessGroupConst', {
        eventUpdate: 'invoice-access-group.updated'
    })
    .factory('InvoiceAccessGroup', function ($resource) {
        return $resource('/crm/api/invoice-access-group/:id', { id: '@id' }, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            autocomplete: { method: 'GET', isArray: true, url: '/crm/api/invoice-access-group/autocomplete' },
        })
    })
    .service('InvoiceAccessGroupService', function ($rootScope, modals, InvoiceAccessGroup, InvoiceAccessGroupConst) {
        this.add = params => {
            let entity = {
                id: null,
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            return modals.open('app/invoice/access-group/edit-modal.html', 'InvoiceAccessGroupDialogController', angular.copy(entity), {}, "$ctrl")
        }
        this.list = () => {
            return modals.open('app/invoice/access-group/list-modal.html', 'InvoiceAccessGroupListController', {}, {size: 'md'}, "$ctrl")
        }
        this.remove = function (item) {
            return modals.confirmDelete(item.name, () => InvoiceAccessGroup.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(InvoiceAccessGroupConst.eventUpdate)))
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceAccessGroupList', {
            parent: 'app',
            url: '/invoice-access-group?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVOICE_ACCESS_GROUP_ADMIN']
            },
            views: {
                'content@': 'invoiceAccessGroupList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceAccessGroup, $q, $stateParams) => InvoiceAccessGroup.list(angular.copy($stateParams)).$promise
            }
        })
    })
